<template>
  <q-dialog v-model="show" persistent>
    <q-card class="padding-horizontal-medium">
      <q-toolbar>
        <q-toolbar-title>Valider la commande ?</q-toolbar-title>
        <q-btn flat round dense icon="close" @click="$emit('cancel')" />
      </q-toolbar>
      <q-card-section>
        <div class="row justify-between items-end">
          <p class="text-h6 q-mb-sm">Résumé</p>
          <p class="text-caption q-mb-sm">{{total.nbrConso}} consommations</p>
        </div>
        <q-separator class="q-mb-sm"/>
        <div v-for="drink in drinks" :key="drink.id" class="row q-pl-md">
          <div class="col-8">- <span class="text-subtitle1 text-capitalize text-weight-medium">{{drink.name}}</span></div>
          <div class="row col-4 justify-between">
            <div class="text-weight-bold">X {{drink.quantite}}</div>
            <div>{{(drink.optimized_price * drink.quantite).toFixed(2) }} €</div>
          </div>
        </div>
        <q-separator class="q-mt-sm"/>
        <div class="row justify-between items-end q-mt-sm">
          <div class="q-mb-none text-h6">Total : </div>
          <div class="q-mb-none text-h6 "> <span class="text-weight-bold">{{total.prix}}</span> €</div>
        </div>
        <template v-if="requiredPaymentMethod">
          <p class="text-subtitle2 q-mt-md q-mb-none">Moyen de paiement</p>
          <q-separator />
          <div>
            <q-radio v-model="paymentMethod" val="1" label="Liquide" />
            <q-radio v-model="paymentMethod" val="2" label="Carte bancaire" />
          </div>
      </template>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn label="Annuler" color="secondary" flat class="q-ml-sm" @click="$emit('cancel')"/>
        <q-btn label="Valider" color="primary" flat @click="validate" :disabled="!paymentMethod && requiredPaymentMethod"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: "Commande",
  data() {
    return {
      drinks: [],
      paymentMethod: null, 
    };
  },
  props: {
    show: Boolean,
    commande: Array,
    requiredPaymentMethod: Boolean,
  },
  methods: {
    validate() {
      this.$emit('validate', {drinks: this.drinks, paymentMethod: this.paymentMethod});
    }
  },
  computed : {
    total() {
      let totalObject = { 
        prix: 0.00, 
        nbrConso: 0
      };
      totalObject = { 
        prix: this.drinks.filter(e => e.quantite > 0).reduce( (oldValue, e) => oldValue + Number.parseFloat(e.optimized_price) * e.quantite, 0.00).toFixed(2),
        nbrConso: this.drinks.filter(e => e.quantite > 0).map(e => e.quantite).reduce( (oldValue, newValue) => oldValue + newValue, 0),
      };
      return totalObject;
    },
  },
  watch: {
    show: function(value) {
      if (this.show == true) {
        this.drinks = [...this.commande.filter(e => e.quantite > 0)];
      } else {
        this.drinks = [];
        this.paymentMethod = null
      }
    }
  }
}
</script>
